import { io, Socket } from 'socket.io-client';

// client/src/lib/socket.ts
const DEFAULT_URL = (typeof window !== 'undefined' && window.location?.origin) || 'http://localhost:4000';
const SERVER_URL = import.meta.env.VITE_SERVER_URL || DEFAULT_URL;

let socket: Socket | null = null;

export function getSocket(): Socket {
    socket ??= io(SERVER_URL, {
        transports: ['websocket'],
        reconnection: true,
        reconnectionAttempts: Infinity,
        reconnectionDelay: 500,
        reconnectionDelayMax: 4000,
        timeout: 20000
    });
    return socket;
}